//This component will show  save filters in the UI  and you can save too.
import React from "react";
import reqwest from "reqwest";
import axios from "axios";
import {
  Slider,
  Row,
  Col,
  Card,
  Select,
  Button,
  Modal,
  List,
  Input,
  Popconfirm,
  Progress,
  message
} from "antd";
import { connect } from "react-redux";
import { activateDatadic,activateScreen,activateFiname,activateRecord,activateStocks, activateLoadid,activateSaveFilter,activateSavedes,activateChange   } from "../redux";
import { CloseCircleTwoTone, PoweroffOutlined,QuestionCircleOutlined } from "@ant-design/icons";
const data = [];

const { Option } = Select;
const { TextArea } = Input;

class SaveFilterOclass extends React.Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.state = {
      value: "",
      data: [],
      isModalVisible: false,
      setIsModalVisible: false,
      loading: false,
      savefill: false,
      isModalsave:this.props.isModalsave,
      fs:this.props.fs, 
    };
    this.handleChange = this.handleChange.bind(this);
    this.handlesave = this.handlesave.bind(this);
    this.handlload = this.handlload.bind(this);
    this.handledel = this.handledel.bind(this);
    this.handlesaveAs = this.handlesaveAs.bind(this);
    this.handleloadAll = this.handleloadAll.bind(this);
    this.error = this.error.bind(this);
    this.warning = this.warning.bind(this);
    this.handleChangedes = this.handleChangedes.bind(this);
  } 
  handleChange(event) {
    console.log(event.target.value )
    this.setState({ value: event.target.value });
    this.props.activateSavedes({name: event.target.value,des:this.props.savedes.des});
  }

  handleChangedes(event) {
   
    this.props.activateSavedes({name: this.props.savedes.name,des:event.target.value});
  }
  
  componentDidMount() {
   
  }

  handleloadAll() {
   
  reqwest({
    url:
      this.props.apppath +
      "/include/api/screener/Simsaveload.cfm?uid=" +
      this.props.auid,
    method: "get",
    type: "json",
  }).then((data) => {
    this.setState({
      
      loading: false,
    });
   this.props.activateSaveFilter(data.results)
  });
  }


  handle(response=2,id) {
    if(id!=0){
    this.props.activateLoadid(id);
    }
    if (response ==0){
      this.error();
      this.setState({
        loading: false,
        savefill: false,
      });
    }else {
                  this.setState({
                    loading: true,
                  });
                  reqwest({
                    url: this.props.apppath + "/include/api/screener/SimsaveloadOne.cfm?uid="+this.props.auid+'&screenerFilterId='+id,
                    method: "get",
                    type: "json",
                  }).then((data) => {
              
                    
                    this.setState({
                      data: data.results,
                      loading: false,
                      savefill: false,
                    });
                   

                    //console.log(this.props.aftersave())
                    this.props.aftersave();
                    //this.fetch();
                    this.props.activateChange('');
                   if (this.state.fs==1){
                   this.handlload(id);
                   this.handleloadAll()
                   } 
                   //this.props.aftersave();
                    //this.fetch();
                   // this.props.activateFiname(this.state.value);
                  });

  } 
  }
  handlload(id) {
    this.setState({
      loading: true,
    });
  
    this.props.activateDatadic({
      FilterDic: JSON.parse(this.state.data[0].FILTER_),
    });
    this.props.activateFiname(this.state.data[0].NAME_);
    
   
    this.setState({
      loading: false,
      isModalVisible:false,
    });
  }

  handledel(id) 
  {
    this.setState({
      loading: true,
    });
    const del = { filterid: id, userId: this.props.auid };
    axios
      .post(this.props.apppath + "/include/api/screener/Simdel.cfm", del)
      .then((response) => this.handle());
  }

  handlesave(va) {
  
   console.log('ssdsdsd',  '-'+this.props.savedes.name+'-') 
  
 
if (this.props.savedes.name!='Untitled New Screen' && this.props.savedes.name!='' && this.props.savedes.name!=undefined && this.props.savedes.name!=' ' && this.props.savedes.name!='Manage My Saved Screens'){
    this.setState({
      loading: true,
      savefill: true,
    });
 
    const article = {
      filter: this.props.datadic.FilterDic,
      filterName:this.props.savedes.name,
      userId: this.props.auid,
      filterDesc: this.props.savedes.des,
      screenerFilterId:this.props.loadid==''?0:this.props.loadid,
    };
    axios
    .post(this.props.apppath + "/include/api/screener/SimsaveEdit.cfm", article)
      .then((response) =>
        //console.log(response.data.results[0].ACT)
        
       this.handle(response.data.results[0].ACT,response.data.results[0].id)
      
      );
  }else{
    this.warning();
  }

  }


  handlesaveAs() {
    
    if (  this.props.savedes.name!="" &&   this.props.savedes.name!="Untitled New Screen" &&   this.props.savedes.name!="Create New Screen" && this.props.savedes.name!=undefined && this.props.savedes.name!=' ' && this.props.savedes.name!='Manage My Saved Screens'){
    this.setState({
      loading: true,
      savefill: true,
    });
  
    const article = {
      filter: this.props.datadic.FilterDic,
      filterName:this.props.savedes.name,
      userId: this.props.auid,
      filterDesc: this.props.savedes.des,
      screenerFilterId:0,
     
    };
    axios
    .post(this.props.apppath + "/include/api/screener/SimsaveEdit.cfm", article)
      .then((response) =>
        //console.log(response.data.results[0].ACT)
        this.handle(response.data.results[0].ACT,response.data.results[0].id)
      
      );

    }else{
      this.warning();
    }
  }



  fetch = (params = {}) => {
    this.setState({ loading: true });
    reqwest({
      url: "https://siproupdateonly.s3-accelerate.amazonaws.com/stockScreenerInit.json",
      method: "get",
      type: "json",
      
    }).then((data) => {
      this.props.activateStocks(data.screenRating);

      this.props.activateRecord(data.screenRating.length);

      this.setState({
        loading: false,
     
        pagination: {
          ...params.pagination,
          total: 200,
        },
      });
    });
  };
  HandleReq(id) {
    this.setState({
      lookingTickers: true,
      runscreen:true,
    });

/*     this.props.activateDatadic({
      FilterDic: JSON.parse(this.state.data[id].FILTER_),
    });
    this.props.activateFiname(this.state.data[id].NAME_); */


    this.props.activateScreen(true);
    this.setState({
      count: 40,
    });
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ tables:  [JSON.parse(this.state.data[id].FILTER_)] }),
   
    };
    fetch(
      this.props.apppath + "/include/api/screener/ssfilter.cfm",
      requestOptions
    )
      .then((response) => response.json()
      )
      .then((data /*  this.props.activateStocks(data.filteredData ) */) =>
        this.setState(
          {
            my: data.filteredData,
            lookingTickers: false,
            runscreen:false,
            count: 60,
          },
          () => {
            this.props.activateRecord(data.filteredData.length);
            this.props.activateStocks(data.filteredData )
            this.props.activateScreen(false);
            this.setState({count:100})
          }
        )
      )
      .then((data) => 1)
      .catch((error) => {
     

        this.setState(
          {
            lookingTickers: false,
          },
          () => {
            this.props.activateRecord("No Results");
            this.props.activateScreen(false);
          }
        );
      });
  }

    error = () => {
  if (  this.props.savedes.name!="" &&   this.props.savedes.name!="Untitled New Screen" &&   this.props.savedes.name!="Create New Screen" )  { 
    message.error({
      content: 'Sorry, you cannot use this name. Please use a diffrent name.',
      className: 'custom-class',
      style: {
        marginTop: '40vh',
      },
    });
  }else{
    message.error({
      content: 'This name is in use, please use a new screen name.',
      className: 'custom-class',
      style: {
        marginTop: '40vh',
      },
    });
  }

  };
 


  warning  = () => {
    message.warning ({
      content: 'Sorry, you cannot use this name.Please use a diffrent name.',
      className: 'custom-class',
      style: {
        marginTop: '40vh',
      },
    });
  };
  render() {
    
   

    const handleOk = () => {
      this.setState({
        setIsModalVisible: false,
        isModalVisible: false,
      });
    };

    const handleCancel = () => {
      this.setState({
        setIsModalVisible: false,
        isModalVisible: false,
      });
     
      this.fetch();
      this.props.aftersave();
    };

    const showModal = () => {
      this.setState({
        setIsModalVisible: true,
        isModalVisible: true,
      });
    };

    let  dsihide='';
    let  dsihide2='';

    if(this.props.screen==false){
      dsihide = {
     
      display: 'none',
    };
    dsihide2 = {
     
      display: '',
    };
  }else{
      dsihide = {
     
      display: '',
    };
    dsihide2 = {
     
      display: 'none',
    };
  }
    return (
      <div>
        
  {this.props.isModalsave==true ?
        <Modal
          title="Save Screen"
          visible={true}
          onCancel={this.props.hidecancel}

          footer={[
            <Button
            loading={this.state.savefill}
            onClick={ () => this.handlesave()}
            type="primary"
          >
            Save
          </Button>,
          <Button
            loading={this.state.savefill}
            onClick={this.handlesaveAs}
            type="primary"
          >
            Save As
          </Button>,
            <Button key="back" type="primary"  onClick={this.props.justclosenow}>
              Close
            </Button>,
             ]}
         
        >

          
 

<div  >
        Name   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <Input
        
       /*  defaultValue={this.props.finame} */
            placeholder="Untitled New Screen"
            onChange={this.handleChange}
            style={{ width: "50%" }}
            ref={this.myRef}
          />
         <br></br><br></br>
         <div    style={{ lineHeight: "100px" }}>Description &nbsp;&nbsp;&nbsp;&nbsp; 
         <TextArea maxLength={140}     
          defaultValue={this.props.savedes.des}
         onChange={this.handleChangedes}   style={{ width: "80%",float:'right' }} rows={4} /></div> 
         {/*  <Card>
          <List
            itemLayout="horizontal"
            dataSource={this.state.data}
            loading={this.state.loading}this.props.savedes.des
            renderItem={(item) => (
              <List.Item>
              <List.Item.Meta title={item.NAME_} description="" />
              
            </List.Item>
            )}
          /> </Card> */} </div>
        </Modal>:''}
      </div>
    );
  }
}
 

const mapStateToProps = (state) => ({
  datadic: state.datadic,
  apppath: state.apppath,
  stocks: state.stocks,
  record: state.record,
  auid: state.auid,
  screen: state.screen,
  finame: state.finame,
  loadid: state.loadid,
  savefilter: state.savefilter,
  savedes: state.savedes,
  change: state.change,
});

const mapDispatchToProps = {
  activateDatadic,activateScreen,activateFiname ,activateRecord ,activateStocks, activateLoadid,activateSaveFilter,activateSavedes,activateChange
};

const SaveFilterO = connect(
  mapStateToProps,
  mapDispatchToProps
)(SaveFilterOclass);

export default SaveFilterO;
